/**
 * mutations
 *
 * @Author  Carey.zhou
 * @DATE    create on 2019/9/16
 * @DESC
 */

import * as types from './types'
export const mutations = {
  [types.REFRESH_USER_SHOP_INFO]: (state, res) => {
    const { freeAvailableTimes, monthCardNum, refuelAvailableTimes, vipDays, point, hasFreeUpdate} = res.data
    state.freeTicket = freeAvailableTimes
    state.monthCardNum = monthCardNum
    state.rechargeTicket = refuelAvailableTimes
    state.vipSurplusDays = vipDays
    state.integral = point
    state.isLogin = true
    state.hasFreeUpdate = hasFreeUpdate
  },
  [types.REFRESH_USER_PHONE_INFO]: (state, res) => {
    const { avatarUlr, phone } = res.data
    state.avatarUlr = avatarUlr
    state.phone = phone
  },
  [types.REFRESH_USER_PLATFORM]: (state, res) => {
    const { platform } = res
    if (platform) {
      state.platform = platform
    }
  },
  [types.REFRESH_USER_ID]: (state, id) => {
    state.sessionid = id
  },
  [types.REFRESH_USER_INFO]: (state, data) => {
    state.user_content = data
  },
  [types.REFRESH_USER_OPEN_ID]: (state, id) => {
    state.user_openid = id
  },
  [types.REFRESH_ENTRANCE_APPNAME]: (state, name) => {
    state.entranceAppname = name
  },
  /**
   *
   *
   * 更新userinfo里面的state
  */
  updateUserInfoState: (state, data) => {
    const { key, value } = data
    state[key] = value
  }
}
